import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(15),
  gap: 15,
  backgroundColor: theme.palette.white,
  borderRadius: 8,
  boxShadow: `0 1px 5px ${theme.palette.shadowMd}`,
}));

export const BlockTitle = styled("h3")(({ theme }) => ({
  color: theme.palette.textMuted,
  borderBottom: `1px solid ${theme.palette.borderLight}`,
  fontWeight: 400,
  paddingBottom: 10,
}));

export const PaymentMethodsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
}));

export const PaymentMethodItem = styled("div")(({ theme, $isActive }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(10),
  gap: 5,
  justifyContent: "center",
  alignItems: "flex-start",
  position: "relative",
  backgroundColor: $isActive ? theme.palette.primarySubtle : theme.palette.white,
  border: `1px solid ${$isActive ? theme.palette.primaryLight : theme.palette.borderDefault}`,
  borderRadius: 8,
  cursor: "pointer",
  transition: "all .3s ease-out",

  "& .balance-icon": {
    display: "flex",
    fontSize: 32,
  },

  "& .balance-not-enough": {
    ...theme.mixins.flexCenterCenter,
    fontSize: 12,
    color: theme.palette.searchButtonBg,
  },

  "&:hover": {
    borderColor: theme.palette.primaryLight,
    boxShadow: `0 2px 8px ${theme.palette.primaryAlpha}`,
  },
}));

export const PaymentMethodCheckboxBlock = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 5,
  top: "center",
}));

export const PaymentMethodLogoContainer = styled("div")(({ theme }) => ({
  width: 90,
  height: 48,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const PaymentMethodLogo = styled("img")(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "block",
  maxWidth: 90,
  maxHeight: 48,

  [theme.down("xs")]: {
    maxWidth: 80,
  },
}));

export const PaymentMethodDescription = styled("div")(({ theme, $isActive }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: $isActive ? theme.palette.textPrimary : theme.palette.textMuted,
}));

export const TimelimitAndPaymentButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  gap: 10,
  fontSize: 14,
  color: theme.palette.textPrimary,
}));

export const PaymentButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  ...theme.paddings(0, 15),
  position: "relative",
  fontSize: 20,
  border: `.5px solid ${theme.palette.borderDefault}`,
  borderRadius: 8,
  backgroundColor: theme.palette.primary,
  color: theme.palette.white,
  height: 46,
  width: "100%",
  cursor: "pointer",

  transition: "all .3s ease-out",

  "&:hover": {
    backgroundColor: [theme.palette.primaryDark],
  },
}));

export const PaymentButtonLoadingCover = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.primaryDark,
}));
